import * as ReactDOM from "react-dom";
import { IntlProvider } from "react-intl";
import { Provider } from "react-redux";
import { BrowserRouter as Router,	Route,	Switch } from "react-router-dom";
import { applyMiddleware, compose, createStore } from "redux";

import brandingMiddleware from "middleware/branding";
import { isProductionEnvironment } from "ProcessEnvironment";
import reducer from "reducers";
import { indexRoutes } from "routes/indexRoutes";
import SnackbarSpawner from "shared/components/Snackbar/SnackbarSpawner";
import { getLocaleId, getTranslation } from "shared/localization/actions";
import apiMiddleware from "shared/middleware/api";


declare global {
	interface Window {
		__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
	}
}
		

const composeEnhancers = (!isProductionEnvironment() && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
const enhancers = composeEnhancers(applyMiddleware(apiMiddleware, brandingMiddleware));

export const createApp = () => {
	ReactDOM.render(
		<Provider store={createStore(reducer, enhancers)}>
			<IntlProvider messages={getTranslation()} locale={getLocaleId()} defaultLocale="en">
				<SnackbarSpawner />
				<Router>
					<Switch>
						{indexRoutes.map((prop, key) => (
							<Route path={prop.path} component={prop.component} key={key} />
						))}
					</Switch>
				</Router>
			</IntlProvider>
		</Provider>,
		document.getElementById("root"),
	);	
};
